<ng-container *transloco="let t">
	<div mat-dialog-title class="flex items-center justify-end cursor-move" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
		<button
			mat-icon-button
			(click)="close()"
			class="-mr-2 shrink-0 text-slate-400 hover:text-slate-600 transition-colors duration-150"
			[attr.aria-label]="t('commonActions.close')">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content>
		<div class="dialog-body">
			<div class="wrench-container">
				<mat-icon svgIcon="ara:progress_wrench" class="wrench-icon"></mat-icon>
			</div>
			<p class="message">
				{{ t('common.featureInDevelopment') }}
			</p>
			@if (isDevRole) {
				<button mat-flat-button class="dev-button" (click)="continueAsDev()">
					{{ t('common.continueAsDev') }}
				</button>
			}
		</div>
	</mat-dialog-content>
</ng-container>
